import * as React from 'react'

/** @param {{ widths: readonly string[] }} props */
const TableColgroup = ({ widths }) => (
  <colgroup>
    {widths.map((width, index) => (
      <col key={index} style={{ width }} />
    ))}
  </colgroup>
)

export default TableColgroup
